import React from "react";
import {
  OptionContainer,
  OptionContent,
  OptionLabel,
  SettingsOptionContainer,
  SettingsOptionHeading,
} from "../../styles";
import { useTranslation } from "react-i18next";
import { ButtonGroup } from "@caelor/ui";
import { BOOLEAN_OPTIONS, CONTENT_FILTERS } from "./defaults";
import { useRecentlyActiveStore } from "../../../../../../stores/use-recently-active-store";

function ContentSettings() {
  const { t } = useTranslation();

  const { data, updateData } = useRecentlyActiveStore((state) => ({
    data: state.data,
    updateData: state.updateData,
  }));

  const updateContentFilter = ({ isOn, key }) => {
    updateData({
      value: {
        contentFilters: isOn
          ? [...data.contentFilters, key]
          : [...data.contentFilters.filter((item) => item !== key)],
      },
    });
  };

  return (
    <>
      <SettingsOptionContainer>
        <SettingsOptionHeading>
          {t("what-recent-activities-should-be-included")}
        </SettingsOptionHeading>

        <OptionContainer alignItems="flex-start" direction="column">
          <OptionLabel>{t("blog-published")}</OptionLabel>
          <OptionContent full>
            <ButtonGroup
              items={BOOLEAN_OPTIONS}
              value={data.contentFilters.includes(CONTENT_FILTERS.BLOG_CREATED)}
              onClick={(isOn) =>
                updateContentFilter({ isOn, key: CONTENT_FILTERS.BLOG_CREATED })
              }
              i18n={t}
            />
          </OptionContent>
        </OptionContainer>

        <OptionContainer alignItems="flex-start" direction="column">
          <OptionLabel>{t("blog-updated")}</OptionLabel>
          <OptionContent full>
            <ButtonGroup
              items={BOOLEAN_OPTIONS}
              value={data.contentFilters.includes(CONTENT_FILTERS.BLOG_UPDATED)}
              onClick={(isOn) =>
                updateContentFilter({ isOn, key: CONTENT_FILTERS.BLOG_UPDATED })
              }
              i18n={t}
            />
          </OptionContent>
        </OptionContainer>

        <OptionContainer alignItems="flex-start" direction="column">
          <OptionLabel>{t("page-published")}</OptionLabel>
          <OptionContent full>
            <ButtonGroup
              items={BOOLEAN_OPTIONS}
              value={data.contentFilters.includes(CONTENT_FILTERS.PAGE_CREATED)}
              onClick={(isOn) =>
                updateContentFilter({ isOn, key: CONTENT_FILTERS.PAGE_CREATED })
              }
              i18n={t}
            />
          </OptionContent>
        </OptionContainer>

        <OptionContainer alignItems="flex-start" direction="column">
          <OptionLabel>{t("page-updated")}</OptionLabel>
          <OptionContent full>
            <ButtonGroup
              items={BOOLEAN_OPTIONS}
              value={data.contentFilters.includes(CONTENT_FILTERS.PAGE_UPDATED)}
              onClick={(isOn) =>
                updateContentFilter({ isOn, key: CONTENT_FILTERS.PAGE_UPDATED })
              }
              i18n={t}
            />
          </OptionContent>
        </OptionContainer>

        <OptionContainer alignItems="flex-start" direction="column">
          <OptionLabel>{t("comment-posted")}</OptionLabel>
          <OptionContent full>
            <ButtonGroup
              items={BOOLEAN_OPTIONS}
              value={data.contentFilters.includes(
                CONTENT_FILTERS.COMMENT_POSTED
              )}
              onClick={(isOn) =>
                updateContentFilter({
                  isOn,
                  key: CONTENT_FILTERS.COMMENT_POSTED,
                })
              }
              i18n={t}
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>
    </>
  );
}

export default ContentSettings;
